import { connect } from 'react-redux';
import { useSSOTokenHandler } from '../loginWithSSO/useSSOTokenHandler';
import actions from '../loginWithSSO/actions';
import notifications from '../../redux/notifications/actions';
import { t } from '../../i18n';

export const withSSOTokenHandler = WrappedComponent => {
  const WithSSOTokenHandler = props => {
    const { loginWithSSORequest, addNotification } = props;

    useSSOTokenHandler(loginWithSSORequest, addNotification, t);

    return <WrappedComponent {...props} />;
  };

  return connect(null, dispatch => ({
    loginWithSSORequest: data => dispatch(actions.loginWithSSORequest(data)),
    addNotification: data => dispatch(notifications.addNotification(data)),
  }))(WithSSOTokenHandler);
};
